<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card invoice p-0">
          <!-- Card header -->
          <div
            class="d-lg-flex justify-content-between align-items-center mx-2 pb-0 card-header invoice"
          >
            <h5>Pop List</h5>
            <div class="d-flex gap-3">
              <div class="flex-grow-1">
                <input
                  type="text"
                  v-model="searchQuery"
                  class="form-control invoice"
                  placeholder="Search..."
                />
              </div>
              <div class="">
                <button
                  @click="addPopup = true"
                  class="bg-success btn text-white rounded py-0"
                  :style="{ height: '35px' }"
                >
                  Add New
                </button>
              </div>
            </div>
          </div>
          <div class="px-0 pb-0 card-body">
            <!-- Table -->
            <div class="table-responsive" v-if="!dataLoading">
              <div class="card mb-4">
                <div class="card-body px-0 pt-0 pb-2 invoice">
                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th
                            @click="sort('pop_name')"
                            :class="{
                              asc: sortKey === 'pop_name' && sortOrder === 'asc',
                              desc: sortKey === 'pop_name' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            POP Name
                          </th>
                          <th
                            @click="sort('ip_address')"
                            :class="{
                              asc: sortKey === 'ip_address' && sortOrder === 'asc',
                              desc: sortKey === 'ip_address' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Ip Address
                          </th>
                          <th
                            @click="sort('pop_alive_time')"
                            :class="{
                              asc: sortKey === 'pop_alive_time' && sortOrder === 'asc',
                              desc: sortKey === 'pop_alive_time' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Pop Alive Time
                          </th>
                          <th
                            @click="sort('type')"
                            :class="{
                              asc: sortKey === 'type' && sortOrder === 'asc',
                              desc: sortKey === 'type' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Type
                          </th>
                          <th
                            @click="sort('down_type')"
                            :class="{
                              asc: sortKey === 'down_type' && sortOrder === 'asc',
                              desc: sortKey === 'down_type' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Down Type
                          </th>
                          <th class="text-sm">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in paginatedData" :key="index"
                        >
                          <td class="text-sm">
                            <div class="d-flex" style="gap: 10px">
                              <span
                                class="bg-danger d-flex justify-content-center align-items-center text-white fw-bold"
                                style="
                                  width: 40px;
                                  height: 40px;
                                  border-radius: 10px;
                                  font-size: 14px;
                                "
                              >
                                {{ item.pop_name ? item.pop_name.charAt(0).toUpperCase() : "?" }}
                              </span>

                              <div>
                                <p class="m-0" style="font-size: 14px">
                                  {{ item.pop_name }}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>{{ item.ip_address }}</td>
                          <td>{{ item.pop_alive_time }}</td>
                          <td>{{ item.type }}</td>
                          <td>
                            <soft-badge v-if="item.type == 'elc' && item.down_type == 'up'" class="bg-success p-1 rounded-1 text-white cursor-pointer text-sm mx-3" variant="gradient" size="sm">{{ item.down_type }}</soft-badge>
                            <soft-badge v-if="item.type == 'elc' && item.down_type == 'dw'" class="bg-danger p-1 rounded-1 text-white cursor-pointer text-sm mx-3" variant="gradient" size="sm">{{ item.down_type }}</soft-badge>
                            <soft-badge v-if="item.type == 'gen' && item.down_type == 'up'" class="bg-danger p-1 rounded-1 text-white cursor-pointer text-sm mx-3" variant="gradient" size="sm">{{ item.down_type }}</soft-badge>
                            <soft-badge v-if="item.type == 'gen' && item.down_type == 'dw'" class="bg-success p-1 rounded-1 text-white cursor-pointer text-sm mx-3" variant="gradient" size="sm">{{ item.down_type }}</soft-badge>
                          </td>
                          <td>
                            <div
                              class="d-flex align-items-center"
                              style="gap: 12px"
                            >
                              <i
                                class="fas fa-edit cursor-pointer"
                                title="Edit"
                               @click="editItem(item)"
                              ></i>
                              <i
                                class="fas fa-trash text-danger cursor-pointer"
                                title="Delete"
                                @click="deleteItem(item.id)"
                              ></i>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <Skalaton />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Sliding Panel -->
    <div class="form-panel" :class="{ 'is-open': addPopup }">
      <div class="form-header">
        <h5 v-if="isEditing">Edit Data</h5>
        <h5 v-else>Add Data</h5>
        <span @click="popup_close" class="item">
          <Close />
        </span>
      </div>
      <div
        class="d-flex flex-column"
        style="gap: 10px"
      >
        <div>
          <label class="form-label">IP Address</label>
          <input
            v-model="formData.ip_address"
            type="text"
            placeholder="Ip Address"
            class="form-control invoice-card"
            required
          />
        </div>

        <!-- Pop Alive Time -->
        <div>
           <label class="form-label">Pop Alive Time</label>
              <input
                v-model="formData.pop_alive_time"
                type="text"
                placeholder="Pop Alive Time"
                class="form-control invoice-card"
              />
        </div>
        <!-- <div>
          <label class="form-label">File Upload</label>
          <div class="d-flex align-items-center gap-2">
            <input
              type="file"
              ref="fileInput"
              class="d-none"
              @change="updateFileName"
            />
            <input
              type="text"
              placeholder=""
              class="form-control invoice-card"
              required
              v-model="selectedFileName"
            />
            <button
              type="button"
              class="btn btn-success"
              style="margin-top: 10px !important"
              @click="selectFile"
            >
              Choose
            </button>
          </div>
        </div> -->

        <div>
          <label class="form-label">Pop</label>
              <select v-model="formData.pop" class="form-control invoice-card">
                <option value="" disabled>Select Pop</option>
                <option v-for="(item,index) in pop_data" :key="index" :value="item.id">{{item.name}}</option>
              </select>
        </div>
        <!-- <div>
          <label class="form-label">Comment</label>
          <textarea name="" id="" class="form-control invoice-card"></textarea>
        </div> -->

        <div>
         <label class="form-label">Type</label>
              <select v-model="formData.type" class="form-control invoice-card">
                <option value="" disabled>Select Type</option>
                <option value="gen">Gen</option>
                <option value="elc">Elc</option>
                <!-- Add other areas as needed -->
              </select>
        </div>

        <div class="mt-4">
          <button type="submit" class="btn btn-success" @click="submitForm">
            {{ isEditing ? "Update" : "Save" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";
import Close from "../components/Icon/Close.vue";
import { useElcMonitorApi } from '@/services/elc-monitor.service';

export default {
  name: "PopList",
  components: { Skalaton, Close },
  data() {
    return {
      data: [], 
      pop_data: [], 
      filteredData: [], 
      searchQuery: '',
      addPopup: false,
      isEditing: false,
      formData: {
        id: null,
        pop_name: '',
        ip_address: '',
        type: '',
        pop_alive_time: '',
        pop: '',
      },
      single_data: {},
      loading: false,
      sortKey: '',
      sortOrder: '',
    };
  },
  computed: {
    paginatedData() {
      return this.filteredData; 
    },
  },
  methods: {
    async fetchData() {
      try {
        const response = await useElcMonitorApi().getPopList();  
        this.data = response.data;
        this.filteredData = this.data; 
      } catch (error) {
        console.error("Error fetching Ip data:", error);
      }
    },
    async fetchPopData() {
      try {
        const response = await useElcMonitorApi().getPop(); 
        this.pop_data = response;
      } catch (error) {
        console.error("Error fetching Pop data:", error);
      }
    },
    submitForm() {
      if (this.formData.id) {
        this.updateItem(this.formData);
      } else {
        this.createItem(this.formData);
      }
    },
    async createItem(formData) {
      this.loading = true;
      try {
        await useElcMonitorApi().createIp(formData);  
        this.fetchData(); 
        this.popup_close();
      } catch (error) {
        console.error("Error creating item:", error);
      } finally {
        this.loading = false;
      }
    },
    async updateItem(formData) {
      this.loading = true;
      try {
        await useElcMonitorApi().updateIp(formData.id, formData);  
        this.fetchData(); 
        this.popup_close();
      } catch (error) {
        console.error("Error updating item:", error);
      } finally {
        this.loading = false;
      }
    },
    async deleteItem(id) {
      this.loading = true;
      try {
        await useElcMonitorApi().deleteIp(id);  
        this.fetchData(); 
      } catch (error) {
        console.error("Error deleting item:", error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.formData = { ...item };
      this.addPopup = true;
      this.isEditing = true;
    },
    popup_close() {
      this.addPopup = false;
      this.isEditing = false;
      this.formData = { id: null, name: '', area_name: '', area: '' };
    },
    sort(column) {
      if (this.sortKey === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = column;
        this.sortOrder = 'asc';
      }
      this.filteredData.sort((a, b) => {
        const valA = a[column];
        const valB = b[column];
        if (this.sortOrder === 'asc') {
          return valA > valB ? 1 : -1;
        } else {
          return valA < valB ? 1 : -1;
        }
      });
    },
  },

   watch: {
            searchQuery(newValue) {
                this.filteredData = this.data.filter(item => {
                    for (let key in item) {
                        if (String(item[key]).toLowerCase().includes(newValue.toLowerCase())) {
                            return true;
                        }
                    }
                    return false;
                });
                this.currentPage = 1;
            }
        },
  mounted() {
    this.fetchData();  
    this.fetchPopData(); 
  },
};
</script>

<style>
td {
  padding: 12px 24px !important;
}

.active-status {
  background: green !important;
  color: white !important;
  padding: 0 5px;
  border-radius: 5px;
}
.dark-mode .active-status {
  color: white !important;
}
.dark-mode .inactive-status {
  color: white !important;
}
.inactive-status {
  background: red !important;
  color: white !important;
  padding: 0 5px;
  border-radius: 5px;
}

/* ===============panel---------- */
.form-panel {
  position: fixed;
  top: 0;
  right: -100%;
  height: 100%;
  width: 400px;
  background: #fff;
  transition: all 0.3s ease;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1050;
}
.dark-mode .form-panel {
  background-color: #061f3e !important;
}
.form-panel.is-open {
  right: 0;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dark-mode .bg {
  background-color: #061f3e !important;
  color: white;
}
</style>
